import React, { useMemo } from "react";
import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";

/**
 * Выпадающий список действий с выбранной путёвкой.
 */
const DocExpsActionsCombo = ({
  canCheckIn,
  canCheckOut,
  canConfirm,
  canDelete,
  canUnconfirm,
  canUncheckIn,
  canUncheckOut,
  canCancel,
  canBook,
  canClearPlacement,
  canRecalculate,
  canChangeNumber,
  canMovePlacement,
  canRefresh,
  recalculateBlockReason,
  onCheckIn,
  onCheckOut,
  onConfirm,
  onDelete,
  onUnconfirm,
  onUncheckIn,
  onUncheckOut,
  onCancelDoc,
  onBook,
  onClearPlacement,
  onRecalculate,
  onChangeNumber,
  onMovePlacement,
  onRefresh
}) => {
  const items = useMemo(
    () => [
      {
        key: "checkIn",
        label: "Заселить",
        disabled: !canCheckIn,
        onClick: onCheckIn
      },
      {
        key: "checkOut",
        label: "Выселить",
        disabled: !canCheckOut,
        onClick: onCheckOut
      },
      {
        key: "confirm",
        label: "Подтвердить",
        disabled: !canConfirm,
        onClick: onConfirm
      },
      { type: "divider" },
      {
        key: "unconfirm",
        label: "Снять подтверждение",
        disabled: !canUnconfirm,
        onClick: onUnconfirm
      },
      {
        key: "uncheckIn",
        label: "Отмена заселения",
        disabled: !canUncheckIn,
        onClick: onUncheckIn
      },
      {
        key: "uncheckOut",
        label: "Отмена выселения",
        disabled: !canUncheckOut,
        onClick: onUncheckOut
      },
      {
        key: "cancel",
        label: "Отменить путёвку",
        disabled: !canCancel,
        danger: true,
        onClick: onCancelDoc
      },
      {
        key: "delete",
        label: "Удалить",
        disabled: !canDelete,
        danger: true,
        onClick: onDelete
      },
      {
        key: "book",
        label: "Бронь",
        disabled: !canBook,
        onClick: onBook
      },
      {
        key: "clearPlacement",
        label: "Очистить размещение",
        disabled: !canClearPlacement,
        onClick: onClearPlacement
      },
      {
        key: "recalculate",
        label: "Пересчёт",
        disabled: !canRecalculate,
        title: !canRecalculate && recalculateBlockReason ? recalculateBlockReason : undefined,
        onClick: onRecalculate
      },
      {
        key: "changeNumber",
        label: "Сменить номер",
        disabled: !canChangeNumber,
        onClick: onChangeNumber
      },
      {
        key: "movePlacement",
        label: "Изменение размещения",
        disabled: !canMovePlacement,
        onClick: onMovePlacement
      },
      { type: "divider" },
      {
        key: "refresh",
        label: "Обновить",
        disabled: !canRefresh,
        onClick: onRefresh
      }
    ],
    [
      canCheckIn,
      canCheckOut,
      canConfirm,
      canDelete,
      canUnconfirm,
      canUncheckIn,
      canUncheckOut,
      canCancel,
      canBook,
      canClearPlacement,
      canRecalculate,
      canChangeNumber,
      canMovePlacement,
      canRefresh,
      recalculateBlockReason,
      onCheckIn,
      onCheckOut,
      onConfirm,
      onDelete,
      onUnconfirm,
      onUncheckIn,
      onUncheckOut,
      onCancelDoc,
      onBook,
      onClearPlacement,
      onRecalculate,
      onChangeNumber,
      onMovePlacement,
      onRefresh
    ]
  );

  return (
    <Dropdown trigger={["click"]} menu={{ items }}>
      <button
        type="button"
        className="doc-exps__actions-more"
        aria-haspopup="menu"
        aria-label="Действия"
        title="Действия"
      >
        <MoreOutlined />
      </button>
    </Dropdown>
  );
};

export default DocExpsActionsCombo;
